import { GeneralStyle } from '@website-builder/model/style/general-style';

export class DividerStyle extends GeneralStyle {
  style = 'uk-divider-small';
  alignment = 'uk-flex-left';
  height = '';
  color = 'tb-divider-black';
  dividerWidth = 20;

  static normalize(styles: Partial<DividerStyle>): DividerStyle {
    const generalStyle: GeneralStyle = GeneralStyle.normalize(styles);
    const pureStyles = new DividerStyle();

    Object.assign(pureStyles, generalStyle);

    pureStyles.style = styles.style ?? pureStyles.style;
    pureStyles.alignment = styles.alignment ?? pureStyles.alignment;
    pureStyles.height = styles.height ?? pureStyles.height;
    pureStyles.color = styles.color ?? pureStyles.color;
    pureStyles.dividerWidth = styles.dividerWidth ?? pureStyles.dividerWidth;

    return pureStyles;
  }
}
